import { Component, OnInit } from '@angular/core';
import { ActionButton, GameDataSource, GameService } from '@fgb/core';
import { TicketTransferAction } from '@fgb/portal-component-library/src/lib/shared/actions';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'fgb-transfer-confirm-page',
  templateUrl: './transfer-confirm-page.component.html',
  styleUrls: ['./transfer-confirm-page.component.scss'],
})
export class TransferConfirmPageComponent implements OnInit {
  tickerTransferAction: ActionButton = new TicketTransferAction(); // Action for recipient form
  constructor(private gameService: GameService, private location: Location) {}

  ngOnInit() {
    firstValueFrom(this.gameService.fetchGames('', GameDataSource.ExternalRef));
  }

  goBack() {
    this.location.back();
  }
}
